import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { GraphQLCommitment, GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { useSupporterQuery } from '@sola/supporter-sdk/hooks/base.ts';
import { paymentMethodsQuery } from '@sola/supporter-sdk/queries.ts';
import { PaymentMethodIcon } from '../../atoms/payment-method-icon/payment-method-icon.tsx';
import { useLocalAlerts } from '../../molecules/local-alerts/local-alerts-provider.tsx';
import { createPaymentPlanSuccessAlert } from '../../utils/alerts.tsx';
import { getPaymentMethodLabel } from '../../utils/payment-methods.ts';
import { PaymentMethodSelectDialog } from '../payment-method-select-dialog/payment-method-select-dialog.tsx';
export const CommitmentDetailsPaymentPlan: React.FC<{
  commitment?: GraphQLCommitment | null;
}> = t0 => {
  const $ = _c(64);
  const {
    commitment
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my", "common"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    addAlerts,
    clearAlerts
  } = useLocalAlerts();
  const {
    data,
    isLoading,
    isError
  } = useSupporterQuery(paymentMethodsQuery);
  commitment?.paymentMethodId;
  let t2;
  bb0: {
    if (!data?.length || !commitment?.paymentMethodId) {
      t2 = undefined;
      break bb0;
    }
    let t3;
    if ($[1] !== commitment?.paymentMethodId || $[2] !== data) {
      let t4;
      if ($[4] !== commitment?.paymentMethodId) {
        t4 = pm => pm?.id === commitment?.paymentMethodId;
        $[4] = commitment?.paymentMethodId;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t3 = data.find(t4);
      $[1] = commitment?.paymentMethodId;
      $[2] = data;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = t3;
  }
  const paymentMethodForCommitment = t2;
  if (!commitment) {
    return null;
  }
  let t3;
  if ($[6] !== addAlerts || $[7] !== clearAlerts) {
    t3 = async () => {
      clearAlerts();
      addAlerts(createPaymentPlanSuccessAlert());
    };
    $[6] = addAlerts;
    $[7] = clearAlerts;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handlePaymentMethodSelection = t3;
  if (isLoading) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Skeleton height={100} width={250} />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (isError) {
    let t4;
    if ($[10] !== t) {
      t4 = t("paymentMethods.queryError.title", {
        count: 1
      });
      $[10] = t;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== t) {
      t5 = t("paymentMethods.queryError.message");
      $[12] = t;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t) {
      t6 = t("ctas.contactSupport.url");
      $[14] = t;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== t) {
      t7 = t("ctas.contactSupport.text");
      $[16] = t;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
      t8 = <a href={t6}>{t7}</a>;
      $[18] = t6;
      $[19] = t7;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] !== t4 || $[22] !== t5 || $[23] !== t8) {
      t9 = <Alert variant="negative" title={t4} message={t5} action={t8} />;
      $[21] = t4;
      $[22] = t5;
      $[23] = t8;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    return t9;
  }
  if (paymentMethodForCommitment) {
    const t4 = paymentMethodForCommitment as GraphQLSupporterPaymentMethod;
    let t5;
    if ($[25] !== t4) {
      t5 = <PaymentMethodIcon paymentMethod={t4} />;
      $[25] = t4;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    let t6;
    if ($[27] !== paymentMethodForCommitment || $[28] !== t) {
      t6 = getPaymentMethodLabel(paymentMethodForCommitment, t);
      $[27] = paymentMethodForCommitment;
      $[28] = t;
      $[29] = t6;
    } else {
      t6 = $[29];
    }
    let t7;
    if ($[30] !== t6) {
      t7 = <span className="label-moderate label-lg">{t6}</span>;
      $[30] = t6;
      $[31] = t7;
    } else {
      t7 = $[31];
    }
    let t8;
    if ($[32] !== t5 || $[33] !== t7) {
      t8 = <div className="flex gap-comfy-md items-center">{t5}{t7}</div>;
      $[32] = t5;
      $[33] = t7;
      $[34] = t8;
    } else {
      t8 = $[34];
    }
    const t9 = commitment?.internalId;
    const t10 = paymentMethodForCommitment?.id;
    const t11 = commitment?.paymentPullDay;
    let t12;
    if ($[35] !== t) {
      t12 = t("commitments.details.paymentMethod.changeLabel");
      $[35] = t;
      $[36] = t12;
    } else {
      t12 = $[36];
    }
    let t13;
    if ($[37] !== t12) {
      t13 = <LinkStyle noUnderline={true} inline={true}><button type="button">{t12}</button></LinkStyle>;
      $[37] = t12;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    let t14;
    if ($[39] !== handlePaymentMethodSelection || $[40] !== t10 || $[41] !== t11 || $[42] !== t13 || $[43] !== t9) {
      t14 = <PaymentMethodSelectDialog commitmentInternalId={t9} currentPaymentMethodId={t10} currentPaymentDay={t11} openTrigger={t13} onSave={handlePaymentMethodSelection} allowAddPaymentMethod={true} />;
      $[39] = handlePaymentMethodSelection;
      $[40] = t10;
      $[41] = t11;
      $[42] = t13;
      $[43] = t9;
      $[44] = t14;
    } else {
      t14 = $[44];
    }
    let t15;
    if ($[45] !== t14 || $[46] !== t8) {
      t15 = <>{t8}{t14}</>;
      $[45] = t14;
      $[46] = t8;
      $[47] = t15;
    } else {
      t15 = $[47];
    }
    return t15;
  }
  let t4;
  if ($[48] !== t) {
    t4 = t("commitments.notRecurring.title");
    $[48] = t;
    $[49] = t4;
  } else {
    t4 = $[49];
  }
  let t5;
  if ($[50] !== t) {
    t5 = t("commitments.notRecurring.message");
    $[50] = t;
    $[51] = t5;
  } else {
    t5 = $[51];
  }
  const t6 = commitment?.internalId;
  let t7;
  if ($[52] !== t) {
    t7 = t("commitments.notRecurring.ctaText");
    $[52] = t;
    $[53] = t7;
  } else {
    t7 = $[53];
  }
  let t8;
  if ($[54] !== t7) {
    t8 = <LinkStyle noUnderline={true} inline={true}><button type="button">{t7}</button></LinkStyle>;
    $[54] = t7;
    $[55] = t8;
  } else {
    t8 = $[55];
  }
  let t9;
  if ($[56] !== handlePaymentMethodSelection || $[57] !== t6 || $[58] !== t8) {
    t9 = <PaymentMethodSelectDialog commitmentInternalId={t6} openTrigger={t8} onSave={handlePaymentMethodSelection} allowAddPaymentMethod={true} />;
    $[56] = handlePaymentMethodSelection;
    $[57] = t6;
    $[58] = t8;
    $[59] = t9;
  } else {
    t9 = $[59];
  }
  let t10;
  if ($[60] !== t4 || $[61] !== t5 || $[62] !== t9) {
    t10 = <Alert variant="warning" title={t4} message={t5} action={t9} />;
    $[60] = t4;
    $[61] = t5;
    $[62] = t9;
    $[63] = t10;
  } else {
    t10 = $[63];
  }
  return t10;
};